import React, { Component } from "react";

class DonateBtn extends Component<{ url: string }, any> {
	render() {
		return (
			<div>
				<a href={this.props.url} target="_blank">
					<button className="btn btn-info d-inline-flex align-items-center">
						PayPal
						<i className="im im-cc-visa text-md mr-1 ml-2-5"></i>
						<i className="im im-cc-amex text-md mr-1"></i>
						<i className="im im-cc-mastercard text-md mr-1"></i>
						<i className="im im-cc-amazon text-md mr-1"></i>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="14"
							height="15"
							viewBox="0 0 24 24"
							style={{ marginTop: "-2px" }}
						>
							<path
								fill="#ffffff"
								d="M20.596 11.185h-.174v-.925h.184c.371 0 .573.156.573.453 0 .307-.202.472-.583.472zm-16.84-.889h-.16v2.021h.16c.385 0 .629-.074.816-.243.206-.184.33-.477.33-.77 0-.293-.124-.577-.33-.761-.197-.178-.431-.247-.816-.247zm20.244-4.296v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-4.173 6.835h.596v-1.228h.077l.825 1.228h.733l-.962-1.288c.449-.091.696-.398.696-.867 0-.572-.394-.902-1.082-.902h-.884v3.057zm-2.086 0h1.691v-.517h-1.095v-.825h1.055v-.518h-1.055v-.678h1.095v-.519h-1.691v3.057zm-3.208-3.057l1.297 3.135h.321l1.32-3.135h-.646l-.826 2.053-.815-2.053h-.651zm-3.094 1.545c0 .916.742 1.659 1.659 1.659.916 0 1.659-.743 1.659-1.659s-.743-1.659-1.659-1.659-1.659.743-1.659 1.659zm-2.528-.014c0 .898.705 1.595 1.613 1.595.257 0 .476-.05.747-.178v-.702c-.238.239-.449.335-.72.335-.6 0-1.027-.435-1.027-1.054 0-.587.44-1.05.999-1.05.284 0 .5.102.747.344v-.702c-.262-.133-.477-.188-.733-.188-.901 0-1.626.711-1.626 1.6zm-3.395 0c0-.902-.674-1.53-1.641-1.53h-.875v3.056h.871c.463 0 .797-.109 1.091-.353.348-.289.554-.724.554-1.173zm.87-1.531h-.596v3.056h.596v-3.056zm1.724 2.154c0 .248-.197.431-.463.431-.284 0-.513-.142-.651-.408l-.385.371c.275.403.605.582 1.058.582.62 0 1.054-.412 1.054-1.004 0-.486-.201-.705-.879-.953-.358-.132-.463-.22-.463-.385 0-.193.187-.339.444-.339.179 0 .325.073.481.247l.312-.408c-.256-.224-.563-.338-.898-.338-.541 0-.953.376-.953.876 0 .421.192.637.752.838.233.082.352.137.412.174.119.078.179.188.179.316zm14.89 1.217s-5.731 4.044-16.226 5.854h14.976c.69 0 1.25-.56 1.25-1.25v-4.604z"
							/>
						</svg>
						<i className="im im-paypal text-sm ml-2"></i>
						{/* <i className="im im-credit-card text-md"></i> */}
					</button>
				</a>
			</div>
		);
	}
}

export default DonateBtn;
